module.exports = __webpack_public_path__ + "static/media/dairy.99b9fbf7.png";